import IBorrowInfo from 'bzx-common/src/domain/borrow/IBorrowInfo'
import { BorrowStore, RootStore } from 'bzx-common/src/stores'
import * as mobx from 'mobx'
import BorrowRequest from 'bzx-common/src/domain/borrow/BorrowRequest'

type BorrowAssetVMProps = 'isBorrowOpen'

export default class BorrowAssetVM {
  rootStore: RootStore
  borrowStore: BorrowStore
  isBorrowOpen = false

  onOpen(borrowInfo: IBorrowInfo) {
    this.borrowStore.set('borrowInfo', borrowInfo)
    this.set('isBorrowOpen', true)
  }

  onClose() {
    this.set('isBorrowOpen', false)
    this.borrowStore.set('borrowInfo', null)
  }

  submit(request: BorrowRequest) {
    this.set('isBorrowOpen', false)
    setTimeout(async () => {
      await this.borrowStore.borrow(request)
    }, 0)
  }

  /**
   * Helper to set values through mobx actions.
   */
  set(prop: BorrowAssetVMProps, value: any) {
    ;(this[prop] as any) = value
  }

  /**
   * Helper to assign multiple props values through a mobx action.
   */
  assign(props: { [key: string]: any }) {
    Object.assign(this, props)
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.borrowStore = rootStore.borrowStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
  }
}
